import { render, staticRenderFns } from "./OtrosProductos.vue?vue&type=template&id=2d4a0bf1&scoped=true"
import script from "./OtrosProductos.vue?vue&type=script&lang=js"
export * from "./OtrosProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a0bf1",
  null
  
)

export default component.exports